var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompletedSlots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0472 9.16608C19.6679 9.81283 19.6484 10.842 19.0006 11.4638L14.0118 16.2565C13.2882 16.9704 12.3305 17.3279 11.3707 17.3279C10.4108 17.3279 9.44883 16.9704 8.71542 16.2543L7.0395 14.7507C6.37217 14.1505 6.31692 13.1235 6.91708 12.4562C7.51725 11.7899 8.54208 11.7325 9.21267 12.3338L10.9373 13.8829C11.1941 14.1321 11.5386 14.1343 11.7455 13.9284L16.7505 9.12058C17.3973 8.49875 18.4232 8.51717 19.0472 9.16608ZM26 13C26 20.1684 20.1684 26 13 26C5.83158 26 0 20.1684 0 13C0 5.83158 5.83158 0 13 0C20.1684 0 26 5.83158 26 13ZM22.75 13C22.75 7.6245 18.3766 3.25 13 3.25C7.62342 3.25 3.25 7.6245 3.25 13C3.25 18.3755 7.62342 22.75 13 22.75C18.3766 22.75 22.75 18.3755 22.75 13Z",
    fill: "#46565C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompletedSlots);
export default __webpack_public_path__ + "static/media/completed_slots.890246787daf7d0609893bb555d8e7f4.svg";
export { ForwardRef as ReactComponent };